
export interface IExcelSheetHeader {
  text: string;
  value: string;
  sortable: boolean;
  missingHeader: string;
}

interface IImporterState {
    rowData: any[];
    excelSheetHeaders: IExcelSheetHeader[];
}

const state: IImporterState =  {
    rowData: [],
    excelSheetHeaders: [],
}

const getters = {

}

const mutations = {
  setExcelSheetHeaders: (importerState: IImporterState, headers: IExcelSheetHeader[]) => {
    state.excelSheetHeaders = headers;
  },
  setRowData: (importerState: IImporterState, rowData: any[]) => {
    state.rowData = rowData;
  },
}

const actions = {

}

export default {
    namespaced: true,
    state, 
    getters,
    mutations,
    actions,
}
